// cache the redirect login for desktop
import { atomWithStorage } from "jotai/utils";

export const $redirectPath = atomWithStorage("authentication.redirectPath", null as string | null);
$redirectPath.debugLabel = "authentication.redirectPathAtom";
